import { render } from "./DialogTemplate.vue?vue&type=template&id=32fc750c&scoped=true&ts=true"
import script from "./DialogTemplate.vue?vue&type=script&lang=ts"
export * from "./DialogTemplate.vue?vue&type=script&lang=ts"

import "./DialogTemplate.vue?vue&type=style&index=0&id=32fc750c&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32fc750c"]])

export default __exports__